import {
  HorizontalProductCard,
  HorizontalProductCardSlim,
  IProductCardProps,
  ProductCard,
  ProductCardSlim,
  SideCartHorizontalProductCard,
} from './ProductCard';
import withChildrenOrderCheck from '../../utils/withChildrenOrderCheck';

export {
  ProductBadges,
  HorizontalProductBadges,
} from './components/ProductBadges';
export { ProductAddToWishlist } from './components/ProductAddToWishlist';
export {
  ProductImage,
  HorizontalProductImage,
} from './components/ProductImage';
export {
  ProductComeBackSoon,
  HorizontalProductComeBackSoon,
} from './components/ProductComeBackSoon';
export { ProductOutOfStock } from './components/ProductOutOfStock';
export {
  HiddenPrice,
  ProductPrice,
  HorizontalProductPrice,
} from './components/ProductPrice';
export { ProductFormatAndUnitPrice } from './components/ProductFormatAndUnitPrice';
export {
  ProductTitle,
  HorizontalProductTitle,
} from './components/ProductTitle';
export { ProductVendor } from './components/ProductVendor';
export {
  ProductAddToCart,
  HorizontalProductAddToCart,
  CartHorizontalProductAddToCart,
} from './components/ProductAddToCart';
export { ProductPictograms } from './components/ProductPictograms';
export { ProductBundle } from './components/ProductBundle';
export { ProductPromotionalOffer } from './components/ProductPromotionalOffer';
export { ProductReviews } from './components/ProductReviews';
export { ProductFormat } from './components/ProductFormat';
export {
  ProductTotalPrice,
  ProductTotalPriceWithPfand,
} from './components/ProductTotalPrice';
export { ProductPfand } from './components/ProductPfand';

const componentToExport =
  process.env.NODE_ENV === 'production'
    ? ProductCard
    : withChildrenOrderCheck<IProductCardProps>(
        ProductCard,
        {
          ProductImage: 1,
          ProductPictograms: 2,
          ProductBadges: 3,
          ProductPrice: 4,
          ProductBundle: 5,
          ProductPromotionalOffer: 5,
          ProductFormatAndUnitPrice: 6,
          ProductFormat: 6,
          ProductTitle: 7,
          ProductAddToWishlist: 8,
          ProductAddToCart: 9,
          ProductVendor: 10,
          ProductReviews: 11,
          ProductOutOfStock: 12,
          ProductComeBackSoon: 12,
        },
        true,
      );

const ProductCardSlimToExport =
  process.env.NODE_ENV === 'production'
    ? ProductCardSlim
    : withChildrenOrderCheck<IProductCardProps>(
        ProductCardSlim,
        {
          ProductImage: 1,
          ProductPictograms: 2,
          ProductBadges: 3,
          ProductPrice: 4,
          ProductBundle: 5,
          ProductPromotionalOffer: 5,
          ProductFormatAndUnitPrice: 6,
          ProductFormat: 6,
          ProductTitle: 7,
          ProductAddToWishlist: 8,
          ProductAddToCart: 9,
          ProductVendor: 10,
          ProductReviews: 11,
          ProductOutOfStock: 12,
          ProductComeBackSoon: 12,
        },
        true,
      );

const HorizontalProductCardToExport =
  process.env.NODE_ENV === 'production'
    ? HorizontalProductCard
    : withChildrenOrderCheck<IProductCardProps>(
        HorizontalProductCard,
        {
          HorizontalProductImage: 1,
          HorizontalProductBadges: 2,
          HorizontalProductTitle: 3,
          ProductAddToWishlist: 4,
          ProductVendor: 5,
          ProductPictograms: 6,
          ProductFormatAndUnitPrice: 7,
          ProductBundle: 8,
          ProductPromotionalOffer: 9,
          ProductFormat: 10,
          HorizontalProductPrice: 11,
          ProductPfand: 11,
          ProductAddToCart: 12,
          ProductOutOfStock: 12,
          HorizontalProductComeBackSoon: 12,
        },
        true,
      );

const CartHorizontalProductCardToExport =
  process.env.NODE_ENV === 'production'
    ? HorizontalProductCard
    : withChildrenOrderCheck<IProductCardProps>(
        HorizontalProductCard,
        {
          HorizontalProductImage: 1,
          HorizontalProductBadges: 2,
          HorizontalProductTitle: 3,
          ProductAddToWishlist: 4,
          ProductVendor: 5,
          ProductPictograms: 6,
          ProductFormatAndUnitPrice: 7,
          ProductBundle: 8,
          ProductPromotionalOffer: 9,
          ProductFormat: 10,
          HorizontalProductPrice: 11,
          ProductPfand: 11,
          CartHorizontalProductAddToCart: 12,
          ProductOutOfStock: 12,
          HorizontalProductComeBackSoon: 12,
        },
        true,
      );

const SideCartHorizontalProductCardToExport =
  process.env.NODE_ENV === 'production'
    ? SideCartHorizontalProductCard
    : withChildrenOrderCheck<Omit<IProductCardProps, 'isInCart'>>(
        SideCartHorizontalProductCard,
        {
          HorizontalProductImage: 1,
          HorizontalProductBadges: 2,
          HorizontalProductTitle: 3,
          ProductAddToWishlist: 4,
          ProductVendor: 5,
          ProductPictograms: 6,
          ProductFormatAndUnitPrice: 7,
          ProductBundle: 8,
          ProductPromotionalOffer: 9,
          ProductFormat: 10,
          HorizontalProductPrice: 11,
          ProductPfand: 12,
          ProductAddToCart: 13,
          ProductQuantity: 13,
        },
        true,
      );

const HorizontalProductCardSlimToExport =
  process.env.NODE_ENV === 'production'
    ? HorizontalProductCardSlim
    : withChildrenOrderCheck<Omit<IProductCardProps, 'isInCart'>>(
        HorizontalProductCardSlim,
        {
          HorizontalProductImage: 1,
          HorizontalProductBadges: 2,
          HorizontalProductTitle: 3,
          ProductAddToWishlist: 4,
          ProductVendor: 5,
          ProductPictograms: 6,
          ProductFormatAndUnitPrice: 7,
          ProductBundle: 8,
          ProductPromotionalOffer: 9,
          ProductFormat: 10,
          HorizontalProductPrice: 11,
          ProductPfand: 13,
          HorizontalProductAddToCart: 13,
          ProductTotalPriceWithPfand: 14,
        },
        true,
      );

export { HorizontalProductCardToExport as HorizontalProductCard };
export { CartHorizontalProductCardToExport as CartHorizontalProductCard };
export { SideCartHorizontalProductCardToExport as SideCartHorizontalProductCard };
export { HorizontalProductCardSlimToExport as HorizontalProductCardSlim };

export { ProductCardSlimToExport as ProductCardSlim };

export default componentToExport;
